import React, { useEffect, useMemo, useState } from 'react';

import { SettingsManager, useSettings, useSportState } from '@atlas/core';
import { Icon, Loader } from '@atlas/ui';

const DropdownMarketTypes = () => {
  const { id, mainMarketTypes } = useSportState();
  const [activeItem, setActiveItem] = useState();
  const { sportMarketTypes } = useSettings();

  const defaultMarketTypes = JSON.parse(sportMarketTypes || '{}');

  const marketTypes = useMemo(
    () =>
      (mainMarketTypes || [])
        .sort((a, b) => a.orderPosition - b.orderPosition)
        .map(({ id, name }) => ({ id: `${id}`, name })),
    [mainMarketTypes],
  );

  useEffect(() => {
    if (id && !activeItem) {
      setActiveItem(defaultMarketTypes[id]?.[0] || marketTypes[0]?.id);
    }
  }, [id, activeItem, defaultMarketTypes, marketTypes]);

  useEffect(
    () => () => {
      setActiveItem(undefined);
    },
    [id],
  );

  const handleChange = event => {
    const marketId = event.target.value;
    setActiveItem(marketId);

    const marketTypeState = { [id]: [marketId] };
    SettingsManager.updateSettings({
      sportMarketTypes: JSON.stringify({
        ...defaultMarketTypes,
        ...marketTypeState,
      }),
    });
  };

  if (!marketTypes.length) {
    return (
      <div className="loading-container">
        <Loader className="absolute" />
      </div>
    );
  }

  const selectedMarketType = marketTypes.find(({ id }) => id === activeItem);

  return (
    <div className="dropdown bg select-field-container">
      <div className="dropdown-button">
        <div className="dropdown-button__text">
          {selectedMarketType ? selectedMarketType.name : ''}
        </div>
        <Icon className="dropdown-button__icon-right" name="arrow-down" />
      </div>
      <select className="select-field" onChange={handleChange} value={activeItem}>
        {marketTypes.map(({ id: marketId, name }) => (
          <option key={marketId} value={marketId}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropdownMarketTypes;
